export const STATUSES = [
  { value: "published", label: "Опубликован" },
  { value: "on_process", label: "В обработке" },
  { value: "rejected", label: "Отклонено" },
];
